import { genComponentStyleHook, type FullToken } from '../geek/styleUtil'
import { cyan, slate } from './glowUtil'
import { DOT_PREFIX } from './constant'

const transition = 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'

export default genComponentStyleHook(['Table', 'techTheme'], (token: FullToken) => {
  const { componentCls } = token

  return {
    [`${componentCls}-wrapper ${componentCls}${DOT_PREFIX}`]: {
      transition,
      background: 'transparent',

      [`${componentCls}-thead > tr > th, ${componentCls}-thead > tr > td`]: {
        background: `${cyan[500]}06 !important`,
        borderBottom: `1px solid ${cyan[500]}18 !important`,
        color: `${cyan[300]} !important`,
        fontWeight: 600,
        letterSpacing: '0.5px',
        fontSize: '12px',
        textTransform: 'uppercase' as const,
      },

      [`${componentCls}-tbody > tr > td`]: {
        borderBottom: `1px solid ${cyan[500]}0a !important`,
        transition,
      },

      [`${componentCls}-tbody > tr:hover > td`]: {
        background: `${cyan[500]}0a !important`,
      },

      [`${componentCls}-tbody > tr${componentCls}-row-selected > td`]: {
        background: `${cyan[500]}12 !important`,
      },

      [`${componentCls}-cell-fix-left, ${componentCls}-cell-fix-right`]: {
        background: `${slate[900]} !important`,
      },
    },
  }
})
